import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  DashboardServiceInterface,
  DashboardStats,
  RecentActivity,
  DashboardSummary,
} from "../types/dashboard.types";

export class DashboardService
  extends BaseService
  implements DashboardServiceInterface
{
  async getDashboardStats(): Promise<ApiResult<DashboardStats>> {
    return this.handleRequest<DashboardStats>(
      this.client.get("/api/admin/dashboard/stats"),
    );
  }

  async getRecentActivity(): Promise<ApiResult<RecentActivity[]>> {
    return this.handleRequest<RecentActivity[]>(
      this.client.get("/api/admin/dashboard/activity"),
    );
  }

  async getDashboardSummary(
    activityCount: number = 10,
  ): Promise<ApiResult<DashboardSummary>> {
    return this.handleRequest<DashboardSummary>(
      this.client.get("/api/admin/dashboard/summary", {
        params: { activityCount },
      }),
    );
  }
}
